import React from 'react';
import CityPage from '../CityPage/CityPage';
import image from '../../assets/homePagePhotos/BoatCruize.jpg';

const TorontoPage = () => (
  <CityPage
    city="Toronto"
    region="Ontario"
    country="Canada"
    countryCode="CA"
    routePath="/Toronto"
    currentPage="TorontoPage"
    image={image}
    imageAlt="Boat rentals on Lake Ontario near Toronto"
    intro="Toronto sits on the north shore of Lake Ontario and is one of the best cities in Canada for a day on the water. From the Toronto Islands to the Outer Harbour, you can rent everything from pontoons and Sea-Doos to wake boats and fishing boats — all booked directly from local hosts on WetRentals."
    sections={[
      {
        heading: 'Where to boat in Toronto',
        body:
          "Popular spots include Lake Ontario along the Harbourfront, the Toronto Islands, the Outer Harbour Marina, and Humber Bay. For calmer water, head a little east toward the Scarborough Bluffs or west toward Mimico. WetRentals hosts deliver to a wide range of launch points across the GTA.",
      },
      {
        heading: 'What you can rent in Toronto',
        body:
          'Sea-Doo and Jet Ski rentals, pontoons for parties and family days, fishing boats for lake trout and salmon on Lake Ontario, wake and ski boats for water sports, plus kayaks, canoes and paddleboards for quieter waterways like the Toronto Islands lagoons.',
      },
      {
        heading: 'Why book with WetRentals in Toronto',
        body:
          'Every booking includes safety gear, instant confirmation, host messaging and flexible cancellation. WetRentals is a Canadian platform built for Canadian conditions — and a network of trusted local hosts makes Toronto rentals simple, even on short notice.',
      },
    ]}
    searchUrl="/s?address=Toronto%2C%20Ontario%2C%20Canada&bounds=43.855401%2C-79.115060%2C43.581024%2C-79.639319"
    searchLabel="Browse all boat rentals in Toronto"
  />
);

export default TorontoPage;
